import { Card, Typography } from "@material-tailwind/react";
import Pagination from "components/wps/Pagination";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import ApiService from "utills/ApiService";

const OrderPending = (props: any) => {
  const { token, eventID, applyDate, filter, currentCurrency, ticketPlatform, ticketTab, translate, symbolCurrency, shortenNumber, attendantPaging, setAttendantPage, isMobile } = props;
  const [orderPending, setOrderPending] = useState([] as any);

  useEffect(() => {
    if (token !== '' && eventID !== '') {
      fetchOrderPending();
    }
  }, [eventID, applyDate, filter, token]);

  const fetchOrderPending = async () => {
    try {
      const result = await ApiService.get(`dashboards/orders/${eventID}/order-pending?from_date=${applyDate.start}&to_date=${applyDate.end}&currency=${currentCurrency}&ticket_platform=${ticketPlatform}`, token);

      if (result) {
        setOrderPending(result);
      }

    } catch (error: any) {
      toast.error(error.message);
    }
  }


  const getPaymentMethod = (method: string) => {
    const payment_method = method.toLowerCase();
    switch (payment_method) {
      case 'atm':
        return translate('atm');
      case 'bank_transfer':
        return translate('bank-transfer');
      case 'credit':
        return translate('credit');
      case 'partner_vnpay':
        return 'Partner VNPay';
      case 'vn_pay_b':
        return 'VNPAY';
      case 'vnpay':
        return 'QR Code';
      case 'zalopay':
        return 'ZaloPay';
      case 'viet_qr':
        return 'Viet QR';
      case 'momo':
        return translate('momo');
      case 'voucher':
        return translate('coupon');
      case 'shipcode':
        return 'Ship Code';
      case 'free':
        return translate('free-ticket');
      case 'bnpl':
        return translate('bnpl');
      case 'viettel_money':
        return translate('viettel_money');
      case 'v_atm':
        return translate('v_atm');
      case 'v_credit':
        return translate('v_credit');
      case 'payoo_atm':
        return translate('payoo_atm');
      case 'payoo_credit':
        return translate('payoo_credit');
      case 'onepay_viet_qr':
        return translate('onepay_viet_qr');
      case 'stripe':
        return translate('stripe-payment');
      default:
        return method;
    }
  }

  if (orderPending.length > 0 && ticketTab === 0) {
    return (
      <div className={`w-full rounded-[8px] mt-[16px] ${!isMobile && 'bg-white'}`}>
        <div className={`w-full h-[64px] flex items-center px-[16px] border-b border-[#e9ecff] ${isMobile && 'bg-white'}`}>
          <div className="text-16 font-600 uppercase">{translate('pending-payment')}</div>
        </div>

        <div className="w-full p-[16px] mt-[16px]">
          <div className="w-full">
            <Card
              onPointerEnterCapture="none" onPointerLeaveCapture="none" onResize={() => { }}
              onResizeCapture={() => { }}
              className="h-full w-full overflow-scroll overflow-y-hidden" placeholder="Card name table">
              <table className="w-full min-w-max table-auto text-left">
                <thead className="bg-[#e9ecff]">
                  <tr>
                    <th className="p-4">
                      <Typography
                        variant="small"
                        className="text-14 !font-500"
                        placeholder="Typography"
                        onPointerEnterCapture="none" onPointerLeaveCapture="none" onResize={() => { }}
                        onResizeCapture={() => { }}
                      >
                        {translate('no')}
                      </Typography>
                    </th>

                    <th className="p-4">
                      <Typography
                        variant="small"
                        className="text-14 !font-500"
                        placeholder="Typography"
                        onPointerEnterCapture="none" onPointerLeaveCapture="none" onResize={() => { }}
                        onResizeCapture={() => { }}
                      >
                        {translate('payment-method')}
                      </Typography>
                    </th>

                    <th className="p-4">
                      <Typography
                        variant="small"
                        className="text-14 !font-500"
                        placeholder="Typography"
                        onPointerEnterCapture="none" onPointerLeaveCapture="none" onResize={() => { }}
                        onResizeCapture={() => { }}
                      >
                        {translate('total-orders')}
                      </Typography>
                    </th>

                    <th className="p-4">
                      <Typography
                        variant="small"
                        className="text-14 !font-500"
                        placeholder="Typography"
                        onPointerEnterCapture="none" onPointerLeaveCapture="none" onResize={() => { }}
                        onResizeCapture={() => { }}
                      >
                        {translate('gross-revenue-event')}
                      </Typography>
                    </th>

                    <th className="p-4">
                      <Typography
                        variant="small"
                        className="text-14 !font-500"
                        placeholder="Typography"
                        onPointerEnterCapture="none" onPointerLeaveCapture="none" onResize={() => { }}
                        onResizeCapture={() => { }}
                      >
                        {translate('net-revenue-event')}
                      </Typography>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {
                    orderPending.length > 0 &&
                    orderPending.map((item: any, index: number) => {
                      const isLast = index === orderPending.length - 1;
                      const classes = isLast ? "p-4" : "p-4 border-b border-blue-gray-50";

                      return (
                        <tr key={`event_${item.code}_${index}`}>
                          <td className={classes}>
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-normal"
                              placeholder="Typography"
                              onPointerEnterCapture="none" onPointerLeaveCapture="none" onResize={() => { }}
                              onResizeCapture={() => { }}
                            >
                              {index + 1}
                            </Typography>
                          </td>

                          <td className={classes}>
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-normal"
                              placeholder="Typography"
                              onPointerEnterCapture="none" onPointerLeaveCapture="none" onResize={() => { }}
                              onResizeCapture={() => { }}
                            >
                              {getPaymentMethod(item.payment_method)}
                            </Typography>
                          </td>

                          <td className={classes}>
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-normal"
                              placeholder="Typography"
                              onPointerEnterCapture="none" onPointerLeaveCapture="none" onResize={() => { }}
                              onResizeCapture={() => { }}
                            >
                              {item.quantity}
                            </Typography>
                          </td>

                          <td className={classes}>
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-normal"
                              placeholder="Typography"
                              onPointerEnterCapture="none" onPointerLeaveCapture="none" onResize={() => { }}
                              onResizeCapture={() => { }}
                            >
                              {symbolCurrency} {shortenNumber(item.subtotal)}
                            </Typography>
                          </td>

                          <td className={classes}>
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-normal"
                              placeholder="Typography"
                              onPointerEnterCapture="none" onPointerLeaveCapture="none" onResize={() => { }}
                              onResizeCapture={() => { }}
                            >
                              {symbolCurrency} {shortenNumber(item.grand_total)}
                            </Typography>
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </Card>

            {
              attendantPaging &&
              <div className={`board__bottom ${isMobile ? 'mt-[16px]' : 'pagination-desktop'}`}>
                {
                  attendantPaging.total_page > 1 &&
                  <Pagination
                    setPage={setAttendantPage}
                    paging={attendantPaging}
                  />
                }
              </div>
            }
          </div>

        </div>
      </div>
    )
  } else {
    return <></>
  }
}

export default OrderPending;